import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ManualsDownloadedData,
  ExportService,
  ManualDownloadedDataPoint,
  LoggingService,
} from "app/shared";
import { ManualsDownloadedNeverConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";

@Component({
  selector: "manuals-downloaded-never-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class ManualsDownloadedNeverChartComponent
  extends BaseChartLogic<ManualsDownloadedNeverConfig,ManualsDownloadedData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      ManualsDownloadedNeverConfig,
      _ngZone
    );
    this.handleDataSubscription(
      this.analyticsService.manualsDownloadedNeverDataChange
    );
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: ManualDownloadedDataPoint): any {
    return 0;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
  }

  refreshData(): void {
    this.analyticsService.getNotDownloadedManualsData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
